import {execute_with_consent, injectTrackerScript} from "@plaudit/analytics-integrations-api";
import "@plaudit/wp-consent-api";

declare global {
	interface Window {
		plauditAnalyticsIntegrationsApi?: {can_enqueue_analytics: boolean}
	}
}

for (const blocked of document.querySelectorAll<HTMLScriptElement>("script[data-category][type='text/plain'][data-swapped-by='plaudit-analytics']")) {
	const categories = blocked.getAttribute("data-category")?.split(",").map(c => c.trim()).filter(c => c.length > 0) ?? [];
	if (categories.length > 0) {
		execute_with_consent({
			categories: categories as [string, ...string[]],
			allowed() {
				const script = document.createElement("script");
				for (const attr of blocked.attributes) {
					if (attr.name === "data-src") {
						script.setAttribute("src", attr.value);
					} else if (attr.name !== "type") {
						script.setAttributeNode(attr.cloneNode() as Attr);
					}
				}
				if (!blocked.hasAttribute("data-src")) {
					script.text = blocked.text;
				}
				blocked.before(script);
				blocked.remove();
			}
		})
	}
}

(window.plauditAnalyticsIntegrationsProviders ??= []).push = function(...analyticsProviders) {
	const res = Array.prototype.push.apply(this, analyticsProviders);
	if (!window.plauditAnalyticsIntegrationsApi?.can_enqueue_analytics) {
		return res;
	}

	for (const analyticsProviderInstance of analyticsProviders) {
		let active = false;
		execute_with_consent({
			categories: analyticsProviderInstance.categories ?? ['marketing', 'statistics'],
			allowed(dueToUpdate: boolean) {
				if (!active) {
					active = true;
					analyticsProviderInstance.activate({injectTrackerScript});

					if (dueToUpdate) {
						//TODO: If the page has not reloaded after N seconds, should we show a popup asking the user if they'd like to reload the page?
					}
				}
			}
		});
	}
	return res;
};
if (Array.isArray(window.plauditAnalyticsIntegrationsProviders)) {
	window.plauditAnalyticsIntegrationsProviders.push(...window.plauditAnalyticsIntegrationsProviders.splice(0, window.plauditAnalyticsIntegrationsProviders.length));
}
